import React from "react";
import { NavLink } from "react-router-dom";
import Button from "../button/button";

// import ContactsContainer from "./donates-container";

// import "./NavigationItems.css";
import "./donates.css";

function DonatesItems(props) {
  return (
    <div className="donate-item">
      <div className="donate">
        <h3>{props.type}: </h3>{" "}
        <a href={`${props.link}`}>{props.name}</a>
      </div>
      <div>
        {props.isAuth && (
          <>
            <Button design="flat" mode="danger" onClick={props.onDelete}>
              Delete
            </Button>
            <Button design="flat" onClick={props.onStartEdit}>
              Edit
            </Button>
          </>
        )}
      </div>
    </div>
  );
  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default DonatesItems;
